export const REVALIDATE_TIME = 120;
